export default "__VITE_ASSET__uahRzTjq__"